import {
    ScrollSnapAutoplay,
    ScrollSnapDraggable,
    ScrollSnapLoop,
    ScrollSnapPlugin,
    ScrollSnapSlider
} from 'scroll-snap-slider';
import Bowser from 'bowser';
import type { ISetupScrollSnapSlider } from '../shared/types';

export default function setupScrollSnapSlider(props: ISetupScrollSnapSlider) {
    const { sliderRef, autoplay, draggable, loop } = props;
    const plugins: ScrollSnapPlugin[] = [];
    if (autoplay) {
        const intervalDuration = typeof autoplay === 'object' ? autoplay.intervalDuration : undefined;
        const timeoutDuration = typeof autoplay === 'object' ? autoplay.timeoutDuration : undefined;

        plugins.push(new ScrollSnapAutoplay(intervalDuration, timeoutDuration));
    }
    if (draggable) plugins.push(new ScrollSnapDraggable());

    if (typeof window !== 'undefined') {
        // Snap slider package has an issue with loop on Safari 14 and below
        const browser = Bowser.getParser(window?.navigator.userAgent);
        const notLoopCompatible = browser.satisfies({
            desktop: {
                Safari: '<15'
            }
        });

        if (loop && !notLoopCompatible) plugins.push(new ScrollSnapLoop());
    }

    const slider = new ScrollSnapSlider({ element: sliderRef }).with(plugins, true);

    return slider;
}
